module.exports = __webpack_public_path__ + "static/media/iconInvoice.596aae07.svg";